import {getDefaultBuildingId} from '../../../data';
import {getWorkdaysForDate} from '../../../data/timeslots/selectors/index';
import {useAppSelector} from '../../../hooks';

export const useHomeBuildingId_timeslots = (dateKey: string): string => {
  const workdays = useAppSelector(getWorkdaysForDate(dateKey));
  const workday = workdays?.data?.at(0);

  const defaultBuildingId = useAppSelector(getDefaultBuildingId);

  return workday?.status === 'OfficeDay' ? workday.buildingId : defaultBuildingId;
};
